import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MasterDataService } from '@core/services/master-data.service';
import { BaseComponentDirective } from '@core/library/base.component';
import { AuthorizationService } from '@core/services/authorization.service';
import {
  EntityCodes,
  AuthActionCodes,
} from '@core/models/global-entities/global-enums';
import { DialogFactoryService } from '@core/services/dialog-factory.service';
import { NavHeaderService } from '@core/services/nav-header.service';
import { SessionService } from '@core/services/session.service';
import { KMTAnalyticsService } from '@core/services/analytics.service';
import { UFBootstrapService } from '../../app/core/services/uf-bootstrap-service';
import { AppSettings } from '@core/library/app-settings';

@Component({
  selector: 'kmt-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
})
export class PageComponent extends BaseComponentDirective implements OnInit {
  submenuVisible = false;
  selectedParentRoute: string;
  _EntityCodes = EntityCodes;
  analyticsURL: string = '';
  AppSettings = AppSettings;
  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public masterService: MasterDataService,
    public dialogFactory: DialogFactoryService,
    public authorizationService: AuthorizationService,
    public navHeader: NavHeaderService,
    public sessionService: SessionService,
    public analyticsService: KMTAnalyticsService,
    private ufBootstrapService: UFBootstrapService
  ) {
    super(router, route, masterService, authorizationService, dialogFactory);
  }

  ngOnInit() {
    this.checkAnalytics();
  }

  async checkAnalytics() {
    if (this.CheckAuth_Action(this._AuthActionCodes.Report_Run)) {
      this.analyticsURL = await this.analyticsService.fetchAnalyticsURL();
    }
  }
  // CheckAuthCases(entityCode: EntityCodes): boolean {
  //   let ActionList: AuthActionCodes[] = [];
  //   switch (entityCode) {
  //     case EntityCodes.WorkOrder:
  //       ActionList = [AuthActionCodes.WorkOrder_Add, AuthActionCodes.WorkOrder_Console_View];
  //       return this.CheckAuth_ActionList(ActionList);

  //     case EntityCodes.PM:
  //       ActionList = [AuthActionCodes.PM_Add, AuthActionCodes.PM_Console_View];
  //       return this.CheckAuth_ActionList(ActionList);

  //     case EntityCodes.Task:
  //       ActionList = [AuthActionCodes.Task_Add_Edit, AuthActionCodes.Task_Console_View];
  //       return this.CheckAuth_ActionList(ActionList);

  //     case EntityCodes.CheckList:
  //       ActionList = [AuthActionCodes.Checklist_Add_Edit, AuthActionCodes.Checklist_Console_View];
  //       return this.CheckAuth_ActionList(ActionList);

  //     case EntityCodes.Asset:
  //       ActionList = [AuthActionCodes.Asset_Add_Edit, AuthActionCodes.Asset_Console_View];
  //       return this.CheckAuth_ActionList(ActionList);
  //   }
  // }

  didTapLogout() {
    let dialogRef = this.dialogFactory.openConfirmation({
      title: 'TITLE.TITLE_PLEASE_CONFIRM',
      message: 'LBL.LOGOUT_CONFIRM',
    });
    dialogRef.afterClosed().subscribe((result) => {
      dialogRef = null;
      if (!result) {
        return;
      }
      this.sessionService.Delete_LoggedInUser().finally(() => {
        this.sessionService.Delete_Session();
        if (AppSettings.EnableUnifocusSSO) {
          this.ufBootstrapService.userLogout();
        } else {
          window.location = AppSettings.URL_Central;
        }
      });

    });
  }
}
